import React from 'react';
import './UserProfile.css';
import {Button, ButtonGroup} from 'reactstrap';
import Utils from '../../common/Utils';
import {AdminEndpoints, FBOEndpoints, TractorOwnerEndpoints, UsersEndpoints} from '../../common/ProxyEndpoints';
import HTML from '../../common/HtmlHelpers';
import AppVariables from "../../common/AppVariables";
import SessionStateManager from '../../common/SessionStateManager';
import {broadcastEvent, handleBrowserUnload, notifyUserProfileChanged} from "../../common/Events/EventSource";
import TTLProxy from "../../common/TTLAsyncProxy";
import EntityImageDisplay from "../../components/EntityImageDisplay/EntityImageDisplay";
import DialogCollapseSection from "../../components/DialogCollapseSection/DialogCollapseSection";
import {
    DeliveryConstants,
    DeliveryMethodMap,
    getName,
    Permissions,
    resolveValue,
    ResponseStatus,
    UserRoles
} from "../../common/Constants";
import RoleRender from "../../components/RoleRender/RoleRender";
import Icon from 'react-icons-kit';
import {ic_cancel} from 'react-icons-kit/md'
import {ErrorDisplay} from "../Register/RegisterBase";
import ValidationHelper from '../../common/ValidationHelper';
import MDProgress from 'react-md-progress-bar';
import MDSpinner from 'react-md-spinner';
import SmartDialog from "../../components/SmartDialog/SmartDialog";
import CheckInput from "../../components/CheckInput/CheckInput";
import EventListener from "../../common/EventListener";
import PermissionRender from "../../components/PermissionRender/PermissionRender";
import LocationSelectInput from "../../components/LocationSelectInput/LocationSelectInput";
import EventActions from "../../common/Events/Actions";


const Styles = {

    actionBtn : {
        borderColor: '#20a8d8',
        borderRadius: '2px'
    },

    option:{
        marginBottom: 5
    }

};


class UserProfile extends  React.Component {

    constructor(props) {
        super(props);

        const session = new SessionStateManager('user_profile', true);
        this.session = session;
        this.proxy = TTLProxy.getInstance();

        this.state = {
            isLoaded: session.getState('isLoaded',false),
            user: this.proxy.getUserInfo(),
            faulted: false,
            errorMessage: null,
            dirty: false,
            inputValues: {},
            inputErrors: {},
            media: null,
            isBusy: false,
            editInfo: false
        };

        //
        this.onUserInfoUpdated = this.onUserInfoUpdated.bind(this)
    }

    persistSession(){

        this.session.putStateFrame({
            isLoaded: this.state.isLoaded
        }).save();

    }

    componentWillUnmount(){
        this.persistSession();
    }

    componentWillMount() {

        //  load current state
        const me = this;

        //  load settings
        handleBrowserUnload(() => {
            me.persistSession();
        });

    }

    onUserInfoUpdated(user){

        this.setState({
            user: user
        });

    }

    hasRole(role){
        return Utils.hasRole(this.state.user.role,role);
    }

    updateOption(payload){

        const me = this;
        const proxy = this.proxy;

        this.setState({
            isBusy: true
        });

        return proxy.updateUserEntity(payload).then(user =>{

            me.setState({
                user: user,
                isBusy: false
            });

        }).catch(err => {

            this.setState({
                isBusy: false
            });

            HTML.toastWarning(Utils.getResponseError(err));

        });

    }

    onUpdateUserInfo(){

        //  check for changed inputs
        const values = this.state.inputValues;
        const user  = this.state.user;

        //  get original values
        const _fullName = Utils.getUserName(user);
        const _userName = user.name;
        const _location = this.getUserLocation();

        //  get current input values
        const vUsername = values['username'].trim();
        const vFullName = values['name'].trim();
        const vLocation = this._location ? this._location.getPlaceFull() : null;

        //
        let faultedInputs = {};

        if(vUsername != _userName){

            if(!ValidationHelper.username.rule(vUsername)){
                faultedInputs['username'] = `Invalid or unacceptable username. Username cannot contain any special character and must have a minimum length of ${AppVariables.MinUsernameLength} letters`;
            }

        }

        if(vFullName != _fullName){

            if(vFullName.length < 2 ||  !vFullName[0].match(/[a-zA-Z]/)){
                faultedInputs['name'] = 'Invalid name. Please enter your full name.';
            }

        }

        //  do we have any validation errors??
        if(Object.keys(faultedInputs).length > 0){

            return this.setState({
               inputErrors: faultedInputs
            });
        }

        const operations = [];
        const proxy = this.proxy;

        //
        const _userUpdate = {
            name: vUsername != _userName ? vUsername : undefined,
        };

        if(Object.keys(_userUpdate).find(x => _userUpdate[x] != undefined) != null){
            operations.push(proxy.processRequest(UsersEndpoints.updateUser(user.id,_userUpdate)));
        }


        let entityPayload = {};

        if(_location != null && (vLocation.text != _location.location)){
            entityPayload.location = vLocation.text;
            entityPayload.location_lat = vLocation.lat;
            entityPayload.location_long = vLocation.lng;
        }


        if(vFullName != _fullName){
            entityPayload.name = vFullName;
        }

        if(Object.keys(entityPayload).length > 0){

            let endpoint;
            switch (user.role){
                case UserRoles.FBO:
                    endpoint = FBOEndpoints.update(user.fbo.id,entityPayload);
                    break;
                case UserRoles.Owner:
                    endpoint = TractorOwnerEndpoints.updateOwner(user.owner.id,entityPayload);
                    break;
                case UserRoles.Admin:
                    endpoint = AdminEndpoints.update(user.admin.id ,entityPayload);
                    break;
                case UserRoles.Farmer:
                    endpoint = AdminEndpoints.update(user.farmer.id ,entityPayload);
                    break;

            }

            operations.push(proxy.processRequest(endpoint));
        }


        if(operations.length > 0){

            this.setState({
                isBusy: true
            });

        }

        return Promise.all(operations).then(() => {

            //  update user info
            proxy.processRequest( UsersEndpoints.getMyself() ).then(response =>{

                const user = response.getPayload();
                proxy.setUserInfo(user);

                this.setState({
                    isBusy: false
                });

                //  toggle section
                this.toggleEditInfo();

                //
                if(operations.length > 0) {
                    HTML.toastMessage('Account info updated successfully!');
                }

            }).catch(err =>{

                this.setState({
                    isBusy: false,
                    errorMessage: "Failed applying changes. Please try again!"
                });

            });

        }).catch(err => {

            let statusMsg = 'An unknown error occurred. Please try again';
            const msg = Utils.getResponseError(err);
            if(err.response && err.response.status == ResponseStatus.ValidationError){

                //  check for field and append error
                statusMsg = 'One or more fields were invalid. Fix and retry again!';

            }
            else {
                statusMsg = msg;
            }

            this.setState({
                isBusy: false,
                errorMessage: statusMsg
            });

        });
    }

    renderEditable(key,type,value,ref){

        const _v = this.state.inputValues;
        if(!_v.hasOwnProperty(key)) {
            _v[key] = value;
        }

        let content;
        switch (type){
            case 'location': {
               content = (<LocationSelectInput
                                ref={r => {

                                    if(r) {
                                        r.setLocation(value.location, value.lat, value.lng);
                                    }

                                    ref(r);

                                }}
                                placeholder={"Enter your location here..."}
                                style={{width: '100%', padding: 5}}
                                onPlaceSelected={(place) => {

                                }}
                                types={['(regions)']}
                                onChange={(evt) => {  }}
                                componentRestrictions={{country: AppVariables.PlacesAutoCompleteCountry  }}/>);
            }break;
            default:{

                content = (<input type={type} value={_v[key]} ref={ref} style={{ width: '100%', padding: '6px' }} onChange={(evt) => {
                    let values = this.state.inputValues;
                    values[key] = evt.target.value;
                    this.setState({ inputValues: values });
                }} onBlur={(evt) => {

                    const v = evt.target.value;
                    if(v === ''){
                        evt.target.value = value;
                    }

                }}/>);

            }
        }

        return  <div>
            {content}
            {this.state.inputErrors[key] && <p className="error-hint">{this.state.inputErrors[key]}</p>}
        </div>
    }

    toggleEditInfo(){

        this.setState({
            editInfo: !this.state.editInfo,
            inputValues: {},
            inputErrors: {},
            errorMessage: null
        });

    }

    getUserLocation(){

        const user = this.state.user;
        switch (user.role){

            case UserRoles.FBO:

                return {
                    location: user.fbo.location,
                    lat: user.fbo.location_lat,
                    lng: user.fbo.location_long
                };

            case UserRoles.Owner:

                return {
                    location: user.owner.location,
                    lat: user.owner.location_lat,
                    lng: user.owner.location_long
                };
        }

    }

    handleProfileChanged(user,media){

        //  update media
        Utils.setUserEntityMedia(user,media);

        //  update user payload
        this.proxy.setUserInfo(user);

        //
        notifyUserProfileChanged(media);

        return false;
    }

    renderContent() {

        const state = this.state;
        const user = state.user;
        const role = user.role;
        const entity = Utils.getUserEntity(user);
        const me = this;
        const isEdit = this.state.editInfo;
        const isBusy = this.state.isBusy;

        //
        const _fullName = Utils.getUserName(user);
        const _userName = user.name;
        const _location = this.getUserLocation();

        return <EventListener events="user_info_updated" onEvent={this.onUserInfoUpdated}>

            <div>

                <div className="text-center">

                    <h5>User Profile</h5>

                    <EntityImageDisplay
                        entityName={user.role}
                        crudView={this}
                        entityId={Utils.getUserEntityId(user)}
                        onRemove={this.handleProfileChanged.bind(this,user)}
                        onCompleteUpload={this.handleProfileChanged.bind(this,user)}
                        media={Utils.getUserEntityMedia(user)} />

                    {this.state.isBusy && <MDSpinner/>}

                </div>

                <hr/>

                <DialogCollapseSection title="Info" initiallyOpen={true}>
                    <div className="clearfix">
                        <dl>

                            <dt>Name</dt>
                            <dd>
                                {isEdit ? this.renderEditable('name','text',_fullName, r => this._fullName = r ) : _fullName }
                            </dd>

                            <dt>Username</dt>
                            <dd>
                                {isEdit ? this.renderEditable('username','text',_userName, r => this._userName = r) : _userName }
                            </dd>

                            {(role == UserRoles.Owner || role == UserRoles.FBO) && <div>
                                <dt>Location</dt>
                                <dd>
                                    {isEdit ? this.renderEditable('location','location', _location , r => this._location = r) : (Utils.standardValue(_location.location)) }
                                </dd>
                            </div>}


                            <dt>Email</dt>
                            <dd>
                                {user.email || "N/A"}  <PermissionRender required={[ Permissions.User.ChangeEmail ]}>
                                <a href="#" className="btn-link" onClick={evt => {
                                evt.preventDefault();
                                broadcastEvent(EventActions.ShowChangeEmail);
                            }}><i className="fa fa-wrench"></i></a>
                            </PermissionRender>
                            </dd>

                            <dt>Phone No.</dt>
                            <dd>
                                {user.phone} <PermissionRender required={[ Permissions.User.ChangePhone ]}>
                                <a href="#" className="btn-link" onClick={evt => {
                                evt.preventDefault();
                                broadcastEvent(EventActions.ShowChangePhone);
                            }}><i className="fa fa-wrench"></i></a>
                            </PermissionRender>
                            </dd>

                            <dt>Date Created</dt>
                            <dd>
                                {Utils.formatDateLong(state.user.date_created)}
                            </dd>

                        </dl>

                        {isEdit && <ErrorDisplay error={state.errorMessage} />}

                    </div>

                    {isEdit ?
                        <div className="clearfix">

                            <div className="pull-left">
                                {this.state.isBusy && <MDSpinner size={30}/>}
                            </div>

                            <div className="pull-right">
                                <ButtonGroup>
                                    <Button color="link" style={Styles.actionBtn} onClick={this.onUpdateUserInfo.bind(this)}><i className="fa fa-save"></i> Save Changes</Button>
                                    <Button color="link" style={Styles.actionBtn} onClick={this.toggleEditInfo.bind(this)}><Icon icon={ic_cancel}/> Cancel</Button>
                                </ButtonGroup>
                            </div>

                        </div>: <Button block className="btn-green" onClick={this.toggleEditInfo.bind(this)}><i className="fa fa-edit"></i> Edit</Button>}


                </DialogCollapseSection>

                <RoleRender role={[UserRoles.Admin,UserRoles.Owner]}>
                    <div>
                        <hr/>
                        <DialogCollapseSection title="Settings" initiallyOpen={false}>

                            <div style={{padding:'5px'}}>

                                <CheckInput title="Enable Notifications"
                                            checked={entity.request_notification}
                                            hint="Controls whether requests notifications should be delivered."
                                            onChange={(evt) => {

                                                const value = evt.target.checked;
                                                me.updateOption({
                                                    request_notification:  value
                                                });
                                            }} />

                                <div style={Styles.option}>

                                    <b>Preferred Delivery Mode</b>
                                    <p className="help-block">Indicates the preferred method of receiving notifications or alerts. You can use your email only if it is activated or fallback to use your current phone number.</p>

                                    <select disabled={!entity.request_notification} className="form-control form-input" onChange={(evt) => {

                                        const value = evt.target.value;
                                        const index = resolveValue(DeliveryConstants,value);
                                        me.updateOption({
                                            request_delivery_mode: index
                                        });

                                    }} value={getName(DeliveryConstants,entity.request_delivery_mode)}>
                                        {DeliveryMethodMap.map((item,index) => {
                                            return  <option key={index} value={item}>{item}</option>;
                                        })}
                                    </select>


                                </div>

                                <hr/>

                                <CheckInput title="Enable USSD Service"
                                            checked={entity.ussd_access}
                                            hint="Makes your account accessible via USSD service"
                                            onChange={(evt) =>{

                                                const value = evt.target.checked;
                                                me.updateOption({
                                                    ussd_access: value
                                                });

                                            }} />



                            </div>


                        </DialogCollapseSection>
                    </div>
                </RoleRender>

                {isBusy && <MDProgress overlay={true}/>}

            </div>
        </EventListener>;
    }


    toggle(){
        this._dlg.toggle();
    }

    show(){

        this._dlg.show();

        //  open dialog state
        this.setState({
            editInfo: false
        });

    }

    render() {

        return (<SmartDialog title={"Account Info"} ref={r => this._dlg = r} canExit={() => !this.state.isBusy }>
                    {this.renderContent()}
                </SmartDialog>);

    }

}

export default UserProfile;


// WEBPACK FOOTER //
// ./src/views/UserProfile/UserProfile.js